import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const firebaseConfig = {
    apiKey: "AIzaSyCaCuflYkLnmfKavE2NK7mfAYJBVe783jM",
    authDomain: "bgweb-5c8dd.firebaseapp.com",
    projectId: "bgweb-5c8dd",
    storageBucket: "bgweb-5c8dd.appspot.com",
    messagingSenderId: "525661377711",
    appId: "1:525661377711:web:32d5c8fb33d2460cbbb05a",
    measurementId: "G-29GV0Y26WC"
};


const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
const analytics = getAnalytics(app);


export async function NotiReq(svr) {

  //const store = useSelector((state) => state);
  

    console.log("권한 요청 중...");
    // const permission = await Notification.requestPermission();

    // if (permission === "denied") {
    //     alert('알림을 차단하셨습니다.\n브라우저의 사이트 설정에서 변경하실 수 있습니다.');
    //     console.log("알림 권한 허용 안됨");
    //     return;
    // }

    console.log("알림 권한이 허용됨");

    const token = await getToken(messaging, {
        vapidKey: 'BDsfqwOXDfBnIwpWxLn32xy32u0hY9XbNy4Xlf1GxsgUtT49pgM4U5eDmNfe7rogAyXW75ArW96VhrExHMZB-Ik'
    });


    if (token) {
        console.log("token: ", token);

        if (token != localStorage.getItem('ftkn')) {
            axios.post(svr + 'setnoti', {
                user: localStorage.getItem('uuid'),
                fcm: token,
            }).then((res) => {
                console.log(res);
                localStorage.setItem('ftkn', token);
            }).catch(() => {
                console.log('실패함');
            })
        }
    }
    else console.log("Can not get Token");

    onMessage(messaging, (payload) => {
        console.log("메시지가 도착했습니다.", payload);
    })


}
